/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*
*   File:   ButtonExpand.js
*
*   Desc:   Checkbox widget that implements ARIA Authoring Practices
*           for a menu of links
*/

/*
*   @constructor ButtonExpand
*
*
*/

/**
 * This is the button class for the disclosure pattern. Modified it to
 * fit CP's ES6 standards.
 * Reference: https://www.w3.org/TR/wai-aria-practices/examples/disclosure/disclosure-img-long-description.html
 */
class ButtonExpand {

  /**
   * Constructor for disclosure button.
   * @param  {HTMLDOM} btn The button element that controls the hidden content.
   * @return {[type]}         [description]
   */
  constructor(btn) {
    this.btn = btn;
    this.expanded_text = btn.dataset.expanded;

    this.keyCode = Object.freeze({
      'RETURN': 13
    });
  }

  /**
   * Initialize events for the button
   * @return {[type]} [description]
   */
  init() {
    this.controlledNode = false;
    this.button_text = this.btn.innerHTML;

    let id = this.btn.getAttribute('aria-controls');

    if (id) {
      this.controlledNode = document.getElementById(id);
    }

    this.btn.setAttribute('aria-expanded', 'false');
    this.hideContent();
    this.btn.addEventListener('keydown',    this.handleKeydown.bind(this));
    this.btn.addEventListener('click',      this.handleClick.bind(this));
  }

  /**
   * Shows the hidden content
   * @return {[type]} [description]
   */
  showContent() {
    if (this.controlledNode) {
      this.controlledNode.style.display = 'block';
      this.controlledNode.classList.remove('print-only');
      // Delay required otherwise fade animation won't trigger.
      setTimeout(() => {
        this.controlledNode.classList.add('disclosure__hidden-content--show');
      }, 50);
    }
  }

  /**
   * Hides the content.
   * @type {[type]}
   */
  hideContent() {
    if (this.controlledNode) {
      this.controlledNode.classList.add('print-only');
      this.controlledNode.classList.remove('disclosure__hidden-content--show');
    }
  }


  /**
   * Toggles the hidden content and updates the buttons aria attributes.
   * @return {[type]} [description]
   */
  toggleExpand() {


    if (this.btn.getAttribute('aria-expanded') === 'true') {
      this.btn.setAttribute('aria-expanded', 'false');
      this.btn.innerHTML = this.button_text;
      this.hideContent();

    } else {
      this.btn.setAttribute('aria-expanded', 'true');
      this.btn.innerHTML = this.expanded_text;
      this.showContent();
    }
  }


  /**
   * Handles the keyboard event
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  handleKeydown(event) {
    switch (event.keyCode) {

      case this.keyCode.RETURN:

        this.toggleExpand();

        event.stopPropagation();
        event.preventDefault();
        break;

      default:
        break;
    }
  }


  /**
   * Handles the click event
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  handleClick(event) {
    event.preventDefault();
    this.toggleExpand();
  }
};


/**
 * Initializes the disclosure pattern.
 * @return {[type]} [description]
 */
function initDisclosure() {
  let buttons = Array.from(document.querySelectorAll('.js-disclosure-control'));

  for (let i = 0; i < buttons.length; i++) {
    let be = new ButtonExpand(buttons[i]);
    be.init();
  }
}


export default initDisclosure;
